export default __webpack_public_path__ + "static/media/quiz.4d0258a6.webp";